import type { PlayerView, PuzzleType } from '@il-colpo/engine';

type Chapter = 1 | 2 | 3 | 4 | 5;

/** Puzzle on the table → the tip that explains it, in order of importance, per chapter. */
const BY_PUZZLE: Record<Chapter, readonly (readonly [PuzzleType, string])[]> = {
  1: [['lock', 'lock']],
  2: [
    ['panel', 'panel'],
    ['cameras', 'cameras'],
    ['laser', 'laser'],
  ],
  3: [['safe', 'safe']],
  4: [
    ['corridor', 'corridor'],
    ['panel', 'manual'],
    ['cameras', 'manual'],
  ],
  5: [['vault', 'vault']],
};

/**
 * The coach's tip for what is on the player's screen right now: a key under `tutorial.tips`,
 * or null when there is nothing to say. Pure, so it is tested without a screen.
 */
export function pickTip(chapter: Chapter, view: PlayerView): string | null {
  switch (view.game.phase) {
    case 'briefing':
      return `briefing.c${chapter}`;
    case 'planning':
      if (view.you.role !== 'mastermind') return 'vote';
      return view.planning?.substage === 'awaiting' ? 'build' : 'voting';
    case 'execution':
    case 'escape': {
      if (view.game.phase === 'escape' && view.you.role === 'driver') return 'escape';
      const open = new Set((view.exec?.puzzles ?? []).filter((p) => !p.solved).map((p) => p.type));
      for (const [type, tip] of BY_PUZZLE[chapter]) if (open.has(type)) return tip;
      return chapter === 3 ? 'help' : 'wait';
    }
    case 'hideout':
      return 'hideout';
    case 'reveal':
    case 'ended':
      return null;
  }
}
